import { _ as _defineProperty } from './defineProperty-18999f8e.js';
import { _ as _objectWithoutProperties } from './objectWithoutProperties-00c72f1d.js';
import classNames from 'classnames';
import { j as jsxRuntime } from './jsx-runtime-0f8a08a2.js';
import createUseStyles from './create/index.js';
import { mediaQuery } from './helpers/index.js';
import { BreakPoints, BorderRadiuses, Spacings } from './enums/index.js';
import { FontWeights, FontSizes } from './fonts/index.js';

var styles = createUseStyles({
  root: _defineProperty({
    fontWeight: FontWeights.Medium,
    transition: 'max-height 0.5s ease-in-out',
    transform: 'none',
    position: 'absolute',
    maxHeight: 0,
    left: 0,
    top: 0,
    minWidth: 164,
    zIndex: 50,
    overflow: 'hidden'
  }, mediaQuery(BreakPoints.Large), {
    left: '50%',
    transform: 'translateX(-50%)'
  }),
  body: {
    mixBlendMode: 'normal',
    boxShadow: '0 0 0 1px #E6E6F3 inset',
    height: '100%',
    maxHeight: 220,
    borderRadius: BorderRadiuses.Size_4,
    boxSizing: 'content-box',
    background: '#ffffff',
    padding: [Spacings.Size_2, Spacings.Size_2, Spacings.Size_2, Spacings.Size_4]
  },
  item: {
    transitionDuration: '.3s',
    padding: [Spacings.Size_5, Spacings.Size_8],
    cursor: 'pointer',
    order: 1,
    borderRadius: BorderRadiuses.Size_4,
    fontSize: FontSizes.Size_6,
    color: '#535771',
    fontWeight: FontWeights.Medium,
    lineHeight: '24px',
    textAlign: 'center',
    margin: [Spacings.Size_4, Spacings.Size_4, Spacings.Size_2, Spacings.Size_4],
    '&:hover': {
      color: '#282B36',
      backgroundColor: 'rgba(237, 238, 244, 0.6)'
    }
  },
  selected: {
    color: '#282B36'
  },
  'direction-up': {
    bottom: '100%',
    marginBottom: Spacings.Size_2,
    top: 'unset'
  },
  'direction-down': {
    top: '100%',
    marginTop: Spacings.Size_2
  },
  open: {
    maxHeight: 228
  }
}, {
  name: 'pa-uiLib-dropdown'
});

var _excluded$1 = ["directionUp", "className", "children", "isOpen"];

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function Dropdown(_ref) {
  var _classnames;

  var directionUp = _ref.directionUp,
      className = _ref.className,
      children = _ref.children,
      isOpen = _ref.isOpen,
      props = _objectWithoutProperties(_ref, _excluded$1);

  var classes = styles();
  return /*#__PURE__*/jsxRuntime.jsx("div", _objectSpread$1(_objectSpread$1({
    className: classNames(classes.root, (_classnames = {}, _defineProperty(_classnames, classes['direction-down'], !directionUp), _defineProperty(_classnames, classes['direction-up'], directionUp), _defineProperty(_classnames, classes.open, isOpen), _classnames), className)
  }, props), {}, {
    children: /*#__PURE__*/jsxRuntime.jsx("div", {
      className: classes.body,
      children: children
    })
  }));
}

var _excluded = ["className", "selected", "dataTest", "label"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function Item(_ref) {
  var className = _ref.className,
      selected = _ref.selected,
      dataTest = _ref.dataTest,
      label = _ref.label,
      props = _objectWithoutProperties(_ref, _excluded);

  var classes = styles();
  return /*#__PURE__*/jsxRuntime.jsx("li", _objectSpread(_objectSpread({
    className: classNames(classes.item, _defineProperty({}, classes.selected, selected), className),
    "data-test": dataTest
  }, props), {}, {
    children: label
  }));
}

export { Dropdown as D, Item as I };
//# sourceMappingURL=index-da5c780a.js.map
